<template>

    <div v-if="!agency" class="legal">
        <ul>
            <li v-for="policy in policies" :key="policy.key">
                <router-link :to="{ name: policy.key }">{{ $t(policy.label) }}</router-link>
            </li>
            <li v-if="cookieConsentEnabled"><a href="#" @click.prevent="openCookiePreferences">{{ $t('labels.cookie_preference') }}</a></li>
        </ul>
    </div>

    <div v-else-if="agency" class="legal">
        <span v-html="agency.footer ?? agency.name" />
    </div>

</template>

<style scoped lang="scss">

    .legal {
        @include font-regular(12px);
        background: $color-bg;
        border-top: 1px solid $color-rule;
        color: $color-muted;
        line-height: 1.6em;
        margin-top: auto;
        padding: 20px 20px 40px 20px;
        ul {
            margin: 0;
            padding: 0;
            li {
                float: left;
                list-style: none;
                margin: 0 10px 0 0;
                padding: 0;
            }
        }
        a {
            color: $color-muted;
            text-decoration: underline;
            transition: opacity .3s;
            &:hover {
                opacity: 0.5;
            }
        }
    }

</style>

<script>

import ConsentUtil from '@utils/ConsentUtil';
import LegalPolicies from '@utils/LegalPolicies';

export default {

    data() {
        return {
            policies: LegalPolicies,
        };
    },

    computed: {

        agency() {
            return this.$store.getters.agency;
        },

        cookieConsentEnabled() {
            return ConsentUtil.isRequired();
        },

    },

    methods: {

        openCookiePreferences() {
            this.$store.commit('setModal', 'cookie-preferences');
        },

    },

}

</script>
